import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from './ui/button';
import { ArrowRight, Mail, Phone } from 'lucide-react';

const ContactSection = ({ onCtaClick }) => {
  const { t } = useTranslation();
  
  return (
    <section className="py-24 px-6 bg-burgundy-darker relative overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 right-0 w-96 h-96 bg-cream-gold rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 left-0 w-96 h-96 bg-cream-gold rounded-full blur-3xl"></div>
      </div>
      
      <div className="max-w-4xl mx-auto relative z-10">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold bg-gradient-to-r from-cream-gold via-cream-gold-light to-cream-gold bg-clip-text text-transparent leading-tight mb-4">
            {t('contact.title')}
          </h2>
          <p className="text-xl text-cream-gold-light/80">
            {t('contact.subtitle')}
          </p>
        </div>

        <div className="flex flex-col items-center gap-8">
          {/* Contact Info Box */}
          <div className="w-full max-w-2xl p-8 bg-gradient-to-br from-dark-card to-burgundy-darker rounded-3xl border-2 border-burgundy hover:border-cream-gold transition-colors duration-300 shadow-2xl shadow-cream-gold/20">
            <h3 className="text-2xl font-bold text-cream-gold mb-6 text-center">{t('contact.getInTouch')}</h3>
            
            <div className="grid md:grid-cols-2 gap-6">
              <div className="flex items-center gap-4 p-4 bg-dark-bg/50 rounded-2xl">
                <div className="flex-shrink-0 w-12 h-12 bg-gradient-to-br from-cream-gold to-cream-gold-dark rounded-xl flex items-center justify-center shadow-lg">
                  <Mail className="w-6 h-6 text-burgundy-darkest" />
                </div>
                <div>
                  <p className="text-sm text-cream-gold-light/60">{t('contact.email')}</p>
                  <a href="mailto:business@evoxmedia.co" className="text-base font-semibold text-cream-gold hover:text-cream-gold-light transition-colors">
                    business@evoxmedia.co
                  </a>
                </div>
              </div>
              
              <div className="flex items-center gap-4 p-4 bg-dark-bg/50 rounded-2xl">
                <div className="flex-shrink-0 w-12 h-12 bg-gradient-to-br from-cream-gold to-cream-gold-dark rounded-xl flex items-center justify-center shadow-lg">
                  <Phone className="w-6 h-6 text-burgundy-darkest" />
                </div>
                <div>
                  <p className="text-sm text-cream-gold-light/60">{t('contact.phone')}</p>
                  <a href="tel:+919840084468" className="text-base font-semibold text-cream-gold hover:text-cream-gold-light transition-colors">
                    +91-9840084468
                  </a>
                </div>
              </div>
            </div>
          </div>

          {/* CTA Button */}
          <Button 
            onClick={onCtaClick}
            className="bg-gradient-to-r from-cream-gold to-cream-gold-dark hover:from-cream-gold-dark hover:to-cream-gold text-burgundy-darkest px-10 py-7 text-lg font-bold rounded-full transition-all duration-300 hover:scale-110 hover:shadow-2xl shadow-cream-gold/50 group"
          >
            {t('contact.cta')}
            <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" />
          </Button>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
